import { Navigate, useLocation } from 'react-router-dom'

// The old link-state tabs have no equivalent: mail is now shown by pipeline
// state and by the letter it answers, so those open the whole mailbox.
const LEGACY_TAB_TO_BUCKET: Record<string, string> = {
    linked: 'letter:initial_loc',
    archived: 'archived',
    pending: 'waiting',
}

/**
 * The old Inbox page lived at /comms/inbox with ?mailbox=&tab=&category=.
 * Everything it showed now lives in the per-mailbox workspace, so carry the
 * filters across: a mailbox opens that mailbox's Received tab, no mailbox
 * opens the cross-mailbox view.
 */
const CommsInboxRedirect = () => {
    const { search } = useLocation()
    const from = new URLSearchParams(search)
    const mailbox = from.get('mailbox')
    const to = new URLSearchParams({ tab: 'received' })
    const bucket = LEGACY_TAB_TO_BUCKET[from.get('tab') || '']
    if (bucket) to.set('bucket', bucket)
    if (from.get('category')) to.set('category', from.get('category') as string)
    if (from.get('claim')) to.set('claim', from.get('claim') as string)
    return <Navigate to={`/comms/mailboxes/${mailbox ? encodeURIComponent(mailbox) : 'all'}?${to.toString()}`} replace />
}

export default CommsInboxRedirect
